import { IInjectable } from '@uirouter/angularjs';
import { ApiService } from '../services/api/types';

export interface ACMETenantResponse<T> {
  success: boolean;
  tenant: T;
}

export interface TenantData {
  name: string;
  streetAddress1: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  id: string;
  phoneNumber: string;
  companyUrl: string;
  currencyCode: string;
  timezone: string;
  consumerPage: string;
  giftCertificates: string;
  reviews: string;
}

export function TenantDataResolver(): IInjectable {
  return [
    'ApiService',
    function TenantData(ApiService: ApiService) {
      return ApiService.tenant.view()
    },
  ];
}